import * as angular from 'angular';
import { config } from 'angular/utils/config';

(function () {
    'use strict';

    angular.module('app').factory('ExternalTrade', externalTradeResource);

    function externalTradeResource($resource) {
        return $resource(
            config.monolithApi + '/external-trades',
            {},
            {
                get: {
                    method: 'GET',
                    url: config.monolithApi + '/external-trades/:id',
                    isArray: false
                },
                page: {
                    method: 'GET',
                    url: config.monolithApi + '/external-trades/page',
                    isArray: false
                },
                templates: {
                    method: 'GET',
                    url: config.monolithApi + '/external-trades/templates',
                    isArray: true
                },
                acerSubmissions: {
                    method: 'GET',
                    url:
                        config.monolithApi +
                        '/external-trades/acer-submissions',
                    isArray: true
                },
                shipperHasExternalTrade: {
                    method: 'GET',
                    url:
                        config.monolithApi +
                        '/external-trades/shipper-has-external-trade',
                    isArray: false,
                    interceptor: {
                        response: function (res) {
                            return res.data;
                        }
                    }
                },
                shipperCreateExternalTradeAllowed: {
                    method: 'GET',
                    url:
                        config.monolithApi +
                        '/external-trades/shipper-create-external-trade-allowed',
                    isArray: false,
                    interceptor: {
                        response: function (res) {
                            return res.data;
                        }
                    }
                }
            }
        );
    }
})();
